<div class="header-container">
  <!-- <div class="logo-sci"><img src="assets/images/SCI Logo - Final 1.svg" alt="mondelezlogo" /></div> -->
  <div class="logo-sci"><img src="assets/images/asteriskLogo.png" alt="mondelezlogo" /></div>
  <div class="header-label">Long Term Capacity Planning</div>
  <div class="logo-mondelez">
    <!-- <img src="assets/images/mondelez-logo.svg" alt="mondelezlogo" /> -->
  </div>
</div>
<div style="font-size: 16px" *ngIf="showBetaTestingInfo">
  This tool is currently in <b>Beta Testing</b>, please <a href="mailto: matthew.schafer@ey.com?subject=Mondelez SCI Tool Beta Feedback&body={{ mailBody }}">click here</a> to
  provide your feedback. Historical data for 2021 and 2022 is currently being worked on - please do no use these values as they are dummy numbers.
</div>
